
import React, { useState, useMemo, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import '../companyMaster/companyMaster.scss';
import DeleteModal from '../../components/common/DeleteModal';
import SaveSuccessModel from '../../components/common/SaveSuccessModel';
import { useRolePermission } from '../../hooks/useRolePermission';
import FetchData, { DeleteEntry, GetList } from '../../providers/dataProvider';
import DataFilter from '../../utils/DataFilter';
import DataSearch from '../../utils/DataSearch';
import { CheckNull } from '../../utils/Validate';
import DataTable from '../../components/common/DataTable';
import { SearchComponent } from '../../components/common/SearchComponent';
import { CompanyFilterComp } from '../../components/companyMaster/CompanyFilterComp';
import ErrorMessage from '../../components/common/ErrorMessage';
import CompanyGrid from '../../components/companyMaster/CompanyGrid'
import { SuccessMessages, ErrorMessages } from "../../constants/MessageConstants";
import AdvancedFilterDropdown from '../../components/common/AdvancedFilterDropdown';
import { PlaceHolder } from '../../constants/PlaceHolderConstants';

const CompanyMasterList = () => {
    const navigate = useNavigate();
    const [status, setStatus] = useState([]);
    const [companyName, setCompanyName] = useState([]);
    const [country, setCountry] = useState([]);
    const [companyFilter, setCompanyFilter] = useState({
        id: [],
        countryId: [],
        status: []
    })
    const [companyData, setCompanyData] = useState([]);
    const [search, setSearch] = useState("");
    const [filterColumn, setFilterColumn] = useState([])
    const [filteredResults, setfilterResult] = useState([])
    const [selected, setSelected] = useState([])
    const [clrFilter, setClrFilter] = useState(false);
    const [deleteShow, setDeleteShow] = useState({ show: false, item: "", title: '', textCode: '', text: '', loading: false });
    const [createMsg, setCreateMsg] = useState(null)
    const [successShow, setSuccessShow] = useState(false)
    const [refreshData, setRefreshData] = useState([]);
    const [refreshSearch, setRefreshSearch] = useState(false);
    const { menuRights } = useRolePermission("Company Master");
    const [errorShow, setErrorShow] = useState({
        show: false,
        errorMessage: ""
    });
    const baseColumns = [
        {
            heading: 'Company Name',
            value: 'companyName',
            sortable: true,
        },
        {
            heading: 'webSite',
            value: 'webSite',
            sortable: true,
        },
        {
            heading: 'Authorized Person',
            value: 'authorizedPerson',
            sortable: true,
        },
        {
            heading: 'Country',
            value: 'countryName',
            sortable: true
        },
        {
            heading: 'Status',
            value: 'status',
            sortable: true,
        },
        {
            heading: 'Email',
            value: 'email',
            sortable: true,
        },
        {
            heading: 'Phone',
            value: 'phone',
            sortable: true,
        },

    ]

    const { data, loading, error } = FetchData("company");
    const { data: countrydata, loading: countryLoading, error: countryError } = FetchData("country");

    useEffect(() => {
        let filterdata = companyData.map((filterItem, index) => {
            let countryName = "";
            var countryValue = countrydata.filter(function (item) {
                return item.id === filterItem.countryId;
            });

            if (countryValue) countryName = countryValue[0]?.name
            filterItem.countryName = countryName
            filterItem.status = filterItem.isActive === true ? "Active" : "Inactive"
            return filterItem;
        })

        filterdata = [...filterdata].sort(function (a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt)
        });

        setfilterResult(filterdata)

    }, [companyData, countrydata])

    useEffect(() => {
        if (data) {
            setCompanyData(data);
        }
    }, [data])

    const statusDropdown = [
        { value: "true", label: "Active" },
        { value: "false", label: "Inactive" }
    ]

    const handleChange = (e, index) => {
        const activeData = document.getElementById(index).checked
        if (activeData == false) {
            setSelected(oldData => [...oldData, e.target.value])
        } else {
            setSelected(selected.filter(values => values !== e.target.value))
        }
    };

    const handleFilterChange = (selectedOption, params) => {
  if (params === "id") setCompanyName(selectedOption);
  if (params === "countryId") setCountry(selectedOption);
  if (params === "status") setStatus(selectedOption);

  setCompanyFilter((prev) => ({
    ...prev,
    [params]:
      params === "status"
        ? selectedOption?.label || ""
        : selectedOption?.value || "",
  }));
};

    const handleEdit = (item) => {
        if (item) navigate('/add-new-company', {
            state: {
                row: item,
                id: item?.id,
                canAdd: menuRights?.canAdd,
                canEdit: menuRights?.canEdit
            }
        })
    }

    const SuccessDoneClick = () => {
        setSuccessShow(false);
        GetList("company", "", setRefreshData)
    }

    useEffect(() => {
        if (refreshData?.message === "success") {
            setCompanyData(refreshData?.data)
        }
    }, [refreshData])

    const handleDelete = (item) => {
        setDeleteShow({
            show: true,
            item: item,
            title: 'You want delete this Company?',
            textCode: 'Company Name',
            text: item?.companyName,
            loading: false
        })
    }

    const HandleCancelDelete = () => {
        setDeleteShow({ show: false, item: "", title: '', textCode: '', text: '', loading: false })
    }

    const ErrorDoneClick = () => {
        setErrorShow(
            {
                show: false,
                errorMessage: ""
            })
        setCreateMsg(null);
    }

    const HandleConfirmDelete = (item) => {
        setDeleteShow({
            ...deleteShow,
            loading: true
        })
        DeleteEntry("company", item, setCreateMsg, SuccessMessages.DELETED("Company"), ErrorMessages.DELETED_ERROR("Company"))
    }

    useEffect(() => {
        if (createMsg?.successData === "Successful") {
            if (CheckNull(createMsg?.message) !== "") {
                setDeleteShow({ show: false, item: "", title: '', textCode: '', text: '', loading: false })
                setSuccessShow(true)
            }
        } else {

            if (CheckNull(createMsg?.message) !== "") {
                setDeleteShow({ show: false, item: "", title: '', textCode: '', text: '', loading: false })
                setErrorShow({ show: true, errorMessage: createMsg.message })
                setSuccessShow(false);
            }
        }
    }, [createMsg]);

    const ClearFilter = () => {
        setCompanyFilter({
            id: [],
            countryId: [],
            status: []
        })
        setCompanyName([]);
        setCountry([]);
        setStatus([]);
        setClrFilter(true);
    }

    const RefreshList = () => {
        window.location.reload();
    }

    useEffect(() => {
        if (clrFilter === true) ApplyFilter();
    }, [clrFilter])

    const ApplyFilter = () => {
        let filterResult = [];
        filterResult = DataFilter(companyData, companyFilter);
        filterResult = DataSearch(filterResult, search, baseColumns.filter(({ value }) => !value.includes("status")));
        filterResult = [...filterResult].sort(function (a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt)
        });
        setfilterResult(filterResult)
        setClrFilter(false);
    }

    const ApplySearch = () => {
        let SearchResult = [];
        SearchResult = DataSearch(companyData, search, baseColumns.filter(({ value }) => !value.includes("status")));
        SearchResult = DataFilter(SearchResult, companyFilter);
        SearchResult = [...SearchResult].sort(function (a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt)
        });
        setfilterResult(SearchResult)
        setRefreshSearch(false)
    }

    useEffect(() => {
        let value = baseColumns.filter(({ value }) => !selected.includes(value))
        setFilterColumn(value);
    }, [selected])

    useEffect(() => {
        if (refreshSearch === true) ApplySearch();
    }, [search])

    const RemoveSearch = () => {
        setSearch("");
        setRefreshSearch(true)
    }
    const HandleKeyDown = (event) => {
        if (event.key === 'Enter') {
            ApplySearch();
        }
    }

    const handleView = (item) => {
        navigate('/view-company', {
            state: item
        })
    }

    const addNew = () => {
        navigate('/add-new-company', {
            state: {
                canAdd: menuRights?.canAdd,
                canEdit: menuRights?.canEdit
            }
        })
    }
    const hasActiveFilters = Boolean(companyName?.length || country?.length);

    return (
        <><section className="company-master-list-sec" id="companyMasterList">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 px-0 py-1">
                        <div className="card">
                            <div className="card-body">
                                <div className="row search-area-row">
                                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-4 col-sm-12 col-xs-12 my-auto p-0">
                                        <div>
                                            <p>{filteredResults?.length} Results Found</p>
                                        </div>
                                    </div>
                                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-8 col-sm-12 col-xs-12 my-auto p-0">
                                        <SearchComponent
                                            filteredResults={filteredResults}
                                            search={search}
                                            handleKeyDown={HandleKeyDown}
                                            setSearch={setSearch}
                                            removeSearch={RemoveSearch}
                                            ApplySearch={ApplySearch}
                                            RefreshList={RefreshList}
                                            baseColumns={baseColumns}
                                            selected={selected}
                                            handleChange={handleChange}
                                            data={companyData} 
                                            addNew={addNew}
                                            menuRights={menuRights}
                                            hasActiveFilters={hasActiveFilters}
                                            filterContent={(closeFilter) => (
                                                <AdvancedFilterDropdown
                                                    ApplyFilter={ApplyFilter}
                                                    ClearFilter={ClearFilter}
                                                    startWithFirstOnly
                                                    onCloseFilter={closeFilter}
                                                    fields={[
                                                        {
                                                            value: "id",
                                                            label: "Company",
                                                            placeholder: PlaceHolder.SELECT_COMPANY,
                                                            pageName: "company",
                                                            dpDownName: "company",
                                                            data: companyData,
                                                            valueObject: companyName,
                                                            valueId: companyFilter?.id,
                                                            setState: setCompanyName,
                                                            onChange: (e) => handleFilterChange(e || [], "id"),
                                                        },
                                                        {
                                                            value: "countryId",
                                                            label: "Country",
                                                            placeholder: PlaceHolder.SELECT_COUNTRY,
                                                            pageName: "company",
                                                            dpDownName: "country",
                                                            data: countrydata,
                                                            valueObject: country,
                                                            valueId: companyFilter?.countryId,
                                                            setState: setCountry,
                                                            onChange: (e) => handleFilterChange(e || [], "countryId"),
                                                        },
                                                    ]}
                                                />
                                            )}  />
                                    </div>
                                </div>
                                {/* <!-- search-area-sec ends --> */}
                            </div>
                        </div>
                    </div>
                </div>
                <CompanyGrid
                    filteredResults={filteredResults}
                    handleEdit={handleEdit}
                    handleDelete={handleDelete}
                    handleView={handleView}
                    loading={loading}
                    menuRights={menuRights}
                    moduleName='company' />
            </div>
        </section>
            <div className='container-fluid company-master-list-sec pl-5 pr-5'>
                {/* <!-- filter modal start--> */}
                <CompanyFilterComp
                    companyData={companyData}
                    setCompanyName={setCompanyName}
                    companyName={companyName}
                    countryData={countrydata}
                    country={country}
                    setCountry={setCountry}
                    handleFilterChange={handleFilterChange}
                    statusData={statusDropdown}
                    status={status}
                    setStatus={setStatus}
                    ClearFilter={ClearFilter}
                    ApplyFilter={ApplyFilter} 
                    companyFilter={companyFilter}/>
                {/*  <!-- deleteModal--> */}
                <DeleteModal deleteShow={deleteShow} handleCancelDelete={HandleCancelDelete} handleConfirmDelete={HandleConfirmDelete} />
                <ErrorMessage Show={errorShow?.show} errorMessage={errorShow?.errorMessage} ErrorDoneClick={ErrorDoneClick} />
                <SaveSuccessModel show={successShow} createMsg={createMsg} setShow={setSuccessShow} SuccessDoneClick={SuccessDoneClick} />

                {/* <!-- NotFound--> */}
                {/* <NotFound /> */}
            </div></>
    )
}

export default CompanyMasterList
